export default __webpack_public_path__ + "static/media/download.e50c1723.svg";